export default __webpack_public_path__ + "static/media/bora.70cea8a7.png";